<template>
  <div>
    <SelectedCategoriesBubble
      :isAdminPage="isAdminPage"
      :subCategoryIds="this.competition.fundId.selectedSubCategories"
    />

    <p v-show="competition.fundId.productData.productDescription && showOnAdminPageOnly" class="mt-3">
      <b>Termék leírása: </b>
      {{ competition.fundId.productData.productDescription }}
    </p>

    <FundRequestTime
      title="Igénylési időszak"
      :requestStartDate="competition.fundId.appearanceDate.requestStartDate"
      :requestEndDate="competition.fundId.appearanceDate.requestEndDate"
      :availableUntilFundIsExhausted="competition.fundId.appearanceDate.availableUntilFundIsExhausted"
    />
    <FundRequestTime
      v-if="showOnAdminPageOnly"
      title="Megjelenési időszak"
      :requestStartDate="competition.fundId.appearanceDate.appearanceStartDate"
      :requestEndDate="competition.fundId.appearanceDate.appearanceEndDate"
    />

    <p v-show="competition.fundId.productData.linkToProduct && showOnAdminPageOnly" class="mt-3">
      <b>Link a termékhez: </b>
      <a :href="competition.fundId.productData.linkToProduct">{{ competition.fundId.productData.linkToProduct }}</a>
    </p>

    <p
      v-show="
        competition.fundId.capitalProductData.financeMin || competition.fundId.capitalProductData.financeMin === 0
      "
      class="mt-3"
    >
      <b>Finanszírozás összegének minimuma:</b>
      {{ numberWithDots(competition.fundId.capitalProductData.financeMin) + ' ' + 'HUF' }}
    </p>
    <p
      v-show="
        competition.fundId.capitalProductData.financeMax || competition.fundId.capitalProductData.financeMax === 0
      "
      class="mt-3"
    >
      <b>Finanszírozás összegének maximuma:</b>
      {{ numberWithDots(competition.fundId.capitalProductData.financeMax) + ' ' + 'HUF' }}
    </p>
    <p v-show="competition.fundId.capitalProductData.finance" class="mt-3 mb-1">
      <b>Finanszírozás formája:</b>
      {{ competition.fundId.capitalProductData.finance }}
    </p>
    <p v-show="competition.fundId.capitalProductData.ownershipShare" class="mt-3 mb-1">
      <b>Megszerzett tulajdonrész:</b>
      {{ competition.fundId.capitalProductData.ownershipShare }}
    </p>
    <p
      v-show="
        (competition.fundId.capitalProductData.investmentTermMin ||
          competition.fundId.capitalProductData.investmentTermMin === 0) &&
          (competition.fundId.capitalProductData.investmentTermMax ||
            competition.fundId.capitalProductData.investmentTermMax === 0)
      "
      class="mt-3"
    >
      <b>Befektetés időtartama:</b> {{ competition.fundId.capitalProductData.investmentTermMin }} -
      {{ competition.fundId.capitalProductData.investmentTermMax }}
      {{ InvestmentTermType[competition.fundId.capitalProductData.investmentTermType] }}
    </p>
    <p v-show="competition.fundId.capitalProductData.yieldExpectation" class="mt-3">
      <b>Hozamelvárás:</b> {{ competition.fundId.capitalProductData.yieldExpectation }}
    </p>

    <div v-show="competition.fundId.guarantee.uniqueConditions.length > 0" class="mt-3">
      <b
        v-if="
          competition.fundId.guarantee.uniqueConditions[0] &&
            competition.fundId.guarantee.uniqueConditions[0].condition.length > 0
        "
        >Egyedi feltételek, kizárások:</b
      >
      <p class="mt-1" v-for="item in competition.fundId.guarantee.uniqueConditions" :key="item.id">
        {{ item.condition }}
      </p>
    </div>
  </div>
</template>

<script>
import FundRequestTime from '../../../../components/FundRequestTime.vue'
import InvestmentTermType from '../../../../enums/InvestmentTermType'
import SelectedCategoriesBubble from './SelectedCategoriesBubble.vue'

export default {
  props: {
    competition: { type: Object, required: true }
  },
  data() {
    return {
      InvestmentTermType,
      isAdminPage: false
    }
  },
  computed: {
    showOnAdminPageOnly() {
      return this.$route.path.includes('/competitions/details')
    }
  },
  methods: {
    numberWithDots(number) {
      if (!this.fieldIsEmpty(number)) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    fieldIsEmpty: function(field) {
      return field === '' || field === null || field === undefined
    },
    formatDate: function(date) {
      if (!date) {
        return 'N/A'
      }
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('.')
    }
  },
  components: { FundRequestTime, SelectedCategoriesBubble },
  created() {
    if (this.$route.path.includes('fund-map')) {
      this.isAdminPage = false
    } else {
      this.isAdminPage = true
    }
  }
}
</script>

<style lang="scss" scoped></style>
